'use strict'

const _ = require('lodash')

let pendingCallbacks = []
let renderCounter = 0
let renderToStringCounter = 0

function flushPendingCallbacksIfNotRenderingAndHasPending() {
    if (pendingCallbacks.length && renderCounter === 0) {
        const copyOfPendingCallbacks = pendingCallbacks
        pendingCallbacks = []
        _.forEach(copyOfPendingCallbacks, function (callback) {
            callback()
        })
        flushPendingCallbacksIfNotRenderingAndHasPending()
    }
}

function finishedRendering() {
    if (renderToStringCounter === 0) {
        renderCounter--
        flushPendingCallbacksIfNotRenderingAndHasPending()
    }
}

function startedRendering() {
    if (renderToStringCounter === 0) {
        renderCounter++
    }
}

function toggleRenderToString(renderingToString) {
    renderToStringCounter += renderingToString ? 1 : -1
}

function callAfterRenderDone(callback) {
    if (!this.isMounted()) {
        console.error('only invoke callAfterRenderDone if the component is mounted') //eslint-disable-line no-console
        return
    }
    if (renderCounter === 0) {
        callback()
    } else {
        pendingCallbacks.push(callback)
    }
}

module.exports = {
    componentDidMount: finishedRendering,
    componentDidUpdate: finishedRendering,
    componentWillMount: startedRendering,
    componentWillUpdate: startedRendering,
    toggleRenderToString,
    callAfterRenderDone
}



// WEBPACK FOOTER //
// ./src/coreUtils/src/main/core/renderDoneMixin.js